import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular';
import { DxSelectBoxTypes } from 'devextreme-angular/ui/select-box';
import { CountriesList } from 'src/app/shared/constants/all-countries-list-constant';
import { COUNTRY_CODE_EXTENDED } from 'src/app/shared/constants/country-code';
import { OrganisationRegistrationDto } from 'src/app/shared/interfaces/ISubscription';

@Component({
  selector: 'app-add-organisation',
  templateUrl: './add-organisation.component.html',
  styleUrl: './add-organisation.component.scss'
})
export class AddOrganisationComponent implements OnInit{

  @ViewChild(DxFormComponent) form: DxFormComponent;
  
  organization: OrganisationRegistrationDto;


  @Input() width='70%';
  @Input() boxShadow = 'rgba(99, 99, 99, 0.2) 0px 2px 20px 6px';
  @Input() isNewUserRegistration = false;
  @Input() isMobile: boolean;
  @Input() emailId;
  @Input() organizationDetails: OrganisationRegistrationDto;
  @Output() goBack = new EventEmitter<OrganisationRegistrationDto>();
  @Output() goForward = new EventEmitter();
  @Output() saveOrganizationDetails = new EventEmitter<OrganisationRegistrationDto>();

  selectedStep = 1;
  countriesList = CountriesList.countries;
  contactPerson;
  email;

  backButtonOptions = {text: 'Back', icon:'arrowleft', width: '150px', useSubmitBehavior: true, type: 'normal', onClick: this.backButtonClicked}
  nextButtonOptions = {text: 'Next', icon: 'arrowright', rtlEnabled: true, width: '150px', type: 'default', onClick: this.nextButtonClicked}

  countryCodeOptions: DxSelectBoxTypes.Properties = {
    labelMode: 'floating',
    searchEnabled: true,
    searchMode: 'contains',
    items: COUNTRY_CODE_EXTENDED,
    valueExpr: 'country_code',
    displayExpr(item) {
      return item === '' ? '' : `${item.country_code} (${item.country_name})`
    },
  }
 
  countryCurrency = [
    {
      displayExpr: 'Danish Krone (DKK)',
      currency: 'DKK',
    },
    {
      displayExpr: 'Euro (EUR)',
      currency: 'EUR',
    },
    // {
    //   displayExpr: 'US Dollar (USD)',
    //   currency: 'USD',
    // },
  ]

  constructor(
    private route: ActivatedRoute
  ){
    this.backButtonClicked = this.backButtonClicked.bind(this);
    this.nextButtonClicked = this.nextButtonClicked.bind(this);
  }

  ngOnInit(): void {

    if(this.organizationDetails){
      this.organization = this.organizationDetails;
    } else {
      this.organization = {
        organisationName: '',
        companyRegistrationNumber: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: '45',
        contactPerson: '',
        contactNumber: '',
        email: '',
        currency: 'DKK',
      };
    }
    this.route.queryParams.subscribe(params => {
      if(params['name'] && params['email']){
        this.organization.contactPerson = params['name'] ?? '';
        this.organization.email = params['email'] ?? ''; 
      }
    });
  }

  backButtonClicked(){
    this.goBack.emit(this.organization);
  }

  
  nextButtonClicked(){
    const result = this.form.instance.validate();
    if (result.isValid) {
      this.saveOrganizationDetails.emit(this.organization);
    } else {
    }
  }
}
